import { render } from "./Clearance.vue?vue&type=template&id=761c278f&scoped=true"
import script from "./Clearance.vue?vue&type=script&lang=js"
export * from "./Clearance.vue?vue&type=script&lang=js"

import "./Clearance.vue?vue&type=style&index=0&id=761c278f&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-761c278f"]])

export default __exports__